// AppGate — thin wrapper that renders the correct screen based on lock state.
//
// CRITICAL (INTEGRATION.md Gotcha #2): Do NOT put lock gating inside the main
// App component. React requires all hooks to be called unconditionally. This
// separate wrapper only calls useAppLock and conditionally renders <App />.
//
// Hydration gate (Stage 11 / LS-1): the IDB-backed persist store resolves
// AFTER first paint. Until `useHydrated()` is true we render a centered
// "Loading your workspace…" placeholder so the user never sees a flash of the
// empty/default state.

import { useAppLock, WelcomeScreen, SetupScreen, LockScreen } from './components/AppLock';
import App from './App';
import { useHydrated } from './store/useHydrated';

export function AppGate() {
  const { isUnlocked, isConfigured, isEnabled, decision } = useAppLock();
  const hydrated = useHydrated();

  if (!hydrated) {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        <div className="app-loading-spinner" aria-hidden="true" />
        <p>Loading your workspace…</p>
      </div>
    );
  }

  if (decision === 'pending') {
    return <WelcomeScreen />;
  }

  if (isEnabled && !isConfigured) {
    return <SetupScreen />;
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return <LockScreen />;
  }

  if (!isUnlocked) {
    return null;
  }

  return <App />;
}
